/**
 * @module ZoomToControl
 */
import "./ZoomToControl.css";
import Control from 'ol/control/Control';
import * as olProj from 'ol/proj';

class ZoomToControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    // Create the container div
    const container = document.createElement('div');
    container.className = 'nhc-map-zoom-to border-top border-gray-10 padding-y-1 padding-x-2';

    container.innerHTML = `
      <h4>Zoom to your location</h4>
      <div class="usa-search usa-search--small margin-top-1" role="search">
        <label class="usa-sr-only" for="zoom-to-location">Zoom to your location</label>
        <input class="usa-input" id="zoom-to-location" type="search" name="search" placeholder="Enter city name">
        <button id="zoom-to-submit" class="usa-button" type="submit">
          Zoom
        </button>
      </div>
    `;

    super({
      element: container,
      target: options.target
    });

    // Store the map object
    this.map = options.map;

    // Bind event handler for the zoom button
    container.querySelector('#zoom-to-submit').addEventListener('click', (e) => {
      e.preventDefault();
      this.citySearch(this.map);
    });

    // Bind event handler for the return key in the input field
    container.querySelector('#zoom-to-location').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.citySearch(this.map);
      }
    });

  }

  /**
   * Retrieve the city name from an input field (search).
   * @param {object} map 
   */
  citySearch(map){
    const city = document.getElementById('zoom-to-location').value;
    const ocUrl = "https://api.opencagedata.com/geocode/v1/json";
    const ocApiKey = "6fd5e2ef16934218a0a5388efdf783c5";
  
    fetch(`${ocUrl}?q=${city}&key=${ocApiKey}`)
    .then(response => response.json())
    .then(data => {
      const lat = data.results[0].geometry.lat;
      const lng = data.results[0].geometry.lng;
      this.goToCity(city, lat, lng, map)
    });
  };
  
  /**
   * Initiate the animated move to the given city.
   * @param {string} city
   * @param {float} lat
   * @param {float} lng
   * @param {object} map
   * @returns {void}
   */
  goToCity(city, lat, lng, map) {
    const duration = 1000;
    map.getView().animate({
      center: olProj.fromLonLat([lng, lat]),
      duration: duration,
      zoom: 8
    });
  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
  }
  
}

export default ZoomToControl;